export default class TransactionRenderKey {
	static TYPE_PLAID = 'TYPE_PLAID';
	static TYPE_TRANSACTION_ID = 'TYPE_TRANSACTION_ID';
	static TYPE_SUBMIT_ID = 'TYPE_SUBMIT_ID';

	static getKey(transaction, typesAllowed = {}) {
		const defaults = {
			[TransactionRenderKey.TYPE_PLAID]: false,
			[TransactionRenderKey.TYPE_TRANSACTION_ID]: false,
			[TransactionRenderKey.TYPE_SUBMIT_ID]: false,
		};
		typesAllowed = { ...defaults, ...typesAllowed };
		if(typesAllowed.TYPE_TRANSACTION_ID && transaction.id) {
			return `id-${transaction.id}`;
		}
		if(typesAllowed.TYPE_PLAID && transaction.plaid_transaction_id) {
			return `plaid-${transaction.plaid_transaction_id}`;
		}
		if(typesAllowed.TYPE_SUBMIT_ID && transaction.submit_id) {
			return `submit-${transaction.submit_id}`;
		}
	}
}
